<template>
  <van-popup
    v-model="value"
    round
    :close-on-click-overlay="false"
    @click-overlay="onClickOverlay"
    position="bottom"
  >
    <van-datetime-picker
      show-toolbar
      :title="title"
      item-height="35px"
      @cancel="cancel"
      type="date"
      @confirm="confirm"
      :cancel-button-text="cancelReset ? '重置' : '取消'"
      :min-date="minDate"
      :max-date="maxDate"
      :formatter="formatter"
    />
  </van-popup>
</template>
<script>
  import { DatetimePicker } from 'vant';
  import moment from 'moment'
  export default {

  props: [
    "title", //标题
    "columns", //头部描述内容
    "valueKey", //选项对象中，文字对应的 key
    "onChange",
    "value",
    "cancelReset",//取消按钮重置
    "minDate",
    "maxDate",

  ],
  data() {
    return {

    };
  },
  methods:{
    //点击遮罩层
    onClickOverlay(){
      this.$emit('input', false)
    },
    confirm(value, index){
      this.$emit('input', false)
      if(this.onChange) {
        let dateStr = moment(value).format('YYYY-MM-DD')
        this.onChange(dateStr, index)
      }
    },
    cancel(){
      this.$emit('input', false)
      if(this.cancelReset) {
        if(this.onChange) {
          this.onChange(null, -1)
        }
      }
    },
    formatter(type, option) {
      if (type === 'year') {
        option += '年';
      } else if (type === 'month') {
        option += '月';
      } else if (type === 'day') {
        option += '日';
      }
      return option;
    }
  }
};
</script>

<style lang="less">
</style>
